/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { DrawRuleRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { DrawRuleListItem } from './accounting-draw-rule.model';

@Injectable()
export class AccountingDrawRuleListTabBusinessService implements InitViewService {
  constructor(private gridLayouts: GridLayoutService,
              private drawRuleRest: DrawRuleRestService) {
  }

  initView(): any {
    return {
      gridLayout: this.gridLayouts.get('drawRules'),
      drawRules: this.findAll(),
    };
  }

  findAll(): Observable<DrawRuleListItem[]> {
    return this.drawRuleRest.findAll();
  }

  checkUsage(drawRule: DrawRuleListItem): Observable<void> {
    return this.drawRuleRest.checkUsage(drawRule);
  }

  remove(drawRule: DrawRuleListItem): Observable<void> {
    return this.drawRuleRest.remove(drawRule);
  }
}
